module.exports = __webpack_public_path__ + "assets/img/driver-btn-28b0ac27.png";